import $ from "jquery";
import "slick-carousel";

const contentReceptenSingle = () => {
  const init = () => {
    galleryRecept();
  };

  const galleryRecept = () => {
    const el = {
      sliderSync: ".js-wrapper-gallery-recepten",
      sliderNav: ".js-wrapper-gallery-recepten .slider-nav",
      sliderFor: ".js-wrapper-gallery-recepten .slider-for",
    };

    if ($(el.sliderSync).length === 0) return;

    $(el.sliderFor).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".slider-nav",
      adaptiveHeight: true, // Set adaptiveHeight to true
    });

    $(el.sliderNav).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: ".slider-for",
      dots: false,
      prevArrow:
        '<div class="arrow-prev"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><style>svg{fill:#cd0b35}</style><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></div>',
      nextArrow:
        '<div class="arrow-next"><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><style>svg{fill:#cd0b35}</style><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></div>',
      focusOnSelect: true,
      infinite: false,
    });
  };

  init();
};
try {
  contentReceptenSingle();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
